module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d7e4447"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4497"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c7_r1#Anch0007",
      "id": "Anch0019"
    }
  }, [_vm._v("Pseudo-Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e4547"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c8_r1#Anch0027",
      "id": "Anch00319"
    }
  }, [_vm._v("Real Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e4597"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c9_r1#Anch0057",
      "id": "Anch00627",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Touched by a Drummer (Saint Kit) "), _c('br'), _vm._v(" Knowing God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e4677"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c10_r1#Anch0037",
      "id": "Anch00443",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Hip-Hop Geography (Extreme Doug) "), _c('br'), _vm._v(" Straight Up")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e4767"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c11_r1#Anch0077",
      "id": "Anch00859",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Waffle House Theology (Wanda the Waitress) "), _c('br'), _vm._v(" Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e4847"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c12_r1#Anch0097",
      "id": "Anch01073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Death to the Phantom (Worthless Grace) "), _c('br'), _vm._v(" Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e4927"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c13_r1#Anch0117",
      "id": "Anch01281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. What the Sheep Do We Know!? "), _c('br'), _vm._v(" (The Kids of Silent Rocks Farm) "), _c('br'), _vm._v(" Openness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c14_r1#Anch0137",
      "id": "Anch01493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Black Hole of Intimacy (Laddie the Dog) "), _c('br'), _vm._v(" Depression")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5167"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c15_r1#Anch0157",
      "id": "Anch016103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Don’t Mess with the EAMC "), _c('br'), _vm._v(" (Mr. Adams, ASE Certified) "), _c('br'), _vm._v(" Institutionalism")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5388"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c16_r1#Anch0178",
      "id": "Anch018115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Pride and Prejudice (My Gay Friend Richard) "), _c('br'), _vm._v(" Wholeness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5468"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c17_r1#Anch0198",
      "id": "Anch020127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Daughters (Jessica, an American Girl) "), _c('br'), _vm._v(" Parenthood")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5548"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c18_r1#Anch0218",
      "id": "Anch022139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. August 7, 1959–July 22, 2000 (Father of Four) "), _c('br'), _vm._v(" Belief")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5628"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c19_r1#Anch0238",
      "id": "Anch024155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. (E) None of the Above "), _c('br'), _vm._v(" (Jill, the Flaming Swim Teacher) "), _c('br'), _vm._v(" Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5738"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c20_r1#Anch0258",
      "id": "Anch026165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Sex, Lies, and Paratroop Deployment "), _c('br'), _vm._v(" (Rescued Varsha) "), _c('br'), _vm._v(" Worldview")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5908"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c21_r1#Anch0278",
      "id": "Anch028177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Great Reversal (Father Jeff) "), _c('br'), _vm._v(" Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e5988"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c22_r1#Anch0298",
      "id": "Anch030189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Left Behind (Dominique, the Abandoned Boy) "), _c('br'), _vm._v(" Scars")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "d7e6068"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c23_r1#Anch0318",
      "id": "Anch032199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Where the Rubber Meets the Road "), _c('br'), _vm._v(" (Rick, the Tire Salesman) "), _c('br'), _vm._v(" Overflow")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6178"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c24_r1#Anch0338",
      "id": "Anch034209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(E)pilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6258"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c25_r1#Anch0358",
      "id": "Anch036213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(e)pilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6338"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c27_r1#Anch0378",
      "id": "Anch038215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e6398"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/palm_ISBN9781418575557_epub_c28_r1#Anch0398",
      "id": "Anch040217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b5469bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/palm_ISBN9781418575557_epub_c6_r1.vue
// module id = 69
// module chunks = 0